import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  BulkDeleteWithConfirmButton,
} from "react-admin";

import GlobalPagination from "../common/GlobalPagination";
import accountFilters from "./accountFilters";
import RoleChipField from "./RoleChipField";

const AccountList = () => (
  <List
    sort={{ field: "emailAddress", order: "ASC" }}
    filters={accountFilters}
    perPage={GlobalPagination.perPage}
    pagination={GlobalPagination.pagination}
  >
    <Datagrid
      rowClick="show"
      bulkActionButtons={
        <BulkDeleteWithConfirmButton mutationMode="pessimistic" />
      }
    >
      <TextField source="emailAddress" />
      <RoleChipField source="role" />
      <ReferenceField
        source="customerId"
        reference="Customer"
        sortable={false}
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>
      <DateField source="lastLogin" showTime />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);
export default AccountList;
